<!--首页-->
<template>
  <div>
    <fy_header></fy_header>
    <fy_banner></fy_banner>
    <fy_index_title></fy_index_title>
    <fy_container v-for="(item,index) in containerList" :key="index" :container="item"></fy_container>
    <fy_sponsor></fy_sponsor>
    <fy_footer></fy_footer>
  </div>
</template>

<script>
  import fy_header from "../components/fy_header"
  import fy_banner from "../components/fy_banner"
  import fy_index_title from "../components/fy_index_title"
  import fy_container from "../components/fy_container"
  import fy_sponsor from "../components/fy_sponsor"
  import fy_footer from "../components/fy_footer"

  import containerList from "../assets/conf"
    export default {
        name: "index",
        components: {
            fy_header,
            fy_banner,
            fy_index_title,
            fy_container,
            fy_footer,
            fy_sponsor,
        },
        data() {
            return {
                containerList
            }
        },
        mounted() {
          this.$router.push('/hardware')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index.vue